import { useState } from 'react'
import type { ImportRow } from '../../lib/excel-import'

interface Props {
  rows: ImportRow[]
  errors: string[]
  statsStartMonth: string | null
  onConfirm: (selected: ImportRow[]) => void
  onCancel: () => void
}

export default function ImportPreview({ rows, errors, statsStartMonth, onConfirm, onCancel }: Props) {
  const [includeDups, setIncludeDups] = useState(false)

  const ok   = rows.filter(r => !r.duplicate)
  const dups = rows.filter(r =>  r.duplicate)
  const selected = includeDups ? rows : ok

  return (
    <div className="import-preview">
      <h3 className="section-title">匯入預覽</h3>

      <div className="import-summary">
        <span className="imp-ok">✓ {ok.length} 筆新資料</span>
        {dups.length > 0 && <span className="imp-dup">⚠ {dups.length} 筆可能重複</span>}
        {errors.length > 0 && <span className="imp-err">✗ {errors.length} 筆錯誤</span>}
        {statsStartMonth && <span className="imp-info">統計起始月：{statsStartMonth.slice(0, 7)}</span>}
      </div>

      {dups.length > 0 && (
        <label className="toggle-row">
          <input type="checkbox" checked={includeDups} onChange={e => setIncludeDups(e.target.checked)} />
          仍要匯入可能重複的 {dups.length} 筆
        </label>
      )}

      {errors.length > 0 && (
        <details className="import-errors">
          <summary>錯誤明細（{errors.length} 筆，不會匯入）</summary>
          <ul>{errors.map((e, i) => <li key={i}>{e}</li>)}</ul>
        </details>
      )}

      <div className="import-actions">
        <button type="button" className="submit-btn" onClick={() => onConfirm(selected)}
          disabled={selected.length === 0}>
          確認匯入 {selected.length} 筆
        </button>
        <button type="button" className="card-btn" onClick={onCancel}>取消</button>
      </div>
    </div>
  )
}
